import { type Theme } from '@biome-design-system/styles';
import { fromTheme as kyruusFromTheme } from '@kyruus/ui-theme';
import { getOverrides, type ThemeContext } from '../utils';

/**
 * Generates MUI Link component style overrides using theme values.
 * @param {object} kyruusTheme - The Kyruus theme object
 * @param {object} biomeTheme - The Biome theme object (which is a MUI theme)
 * @returns {object} MUI Link style overrides for the theme.
 */

export const buildLink = (
  kyruusTheme: Record<string, unknown>,
  biomeTheme: Theme
) => {
  // wrap fromTheme to simplify the code below
  const fromTheme = (themeKey: string) =>
    kyruusFromTheme(themeKey)({ theme: kyruusTheme });

  const colorLink = fromTheme('color_link');

  const { root } = biomeTheme.components?.MuiLink?.styleOverrides || {};

  return {
    defaultProps: {
      color: colorLink,
      underline: 'hover'
    },
    styleOverrides: {
      root: (context: ThemeContext) => ({
        ...getOverrides(root, context),
        textDecoration: 'none',
        '&:visited:not(.MuiBreadcrumbs-root .MuiLink-root)': {
          color: colorLink
        }
      })
    }
  };
};
